import { render, staticRenderFns } from "./CommonLinkCurrency.vue?vue&type=template&id=48dc33b4&"
import script from "./CommonLinkCurrency.vue?vue&type=script&lang=js&"
export * from "./CommonLinkCurrency.vue?vue&type=script&lang=js&"
import style0 from "./CommonLinkCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports